import {Routes} from '@angular/router';

import {getAllPermissionResolver} from '../../shared/services/resolvers/get-all-permission.resolve';
import {getAllProfileResolver} from '../../shared/services/resolvers/get-all-profile.resolve';
import {getCustomersResolver} from '../../shared/services/resolvers/get-customers.resolver';
import {
  getAllPollsResolver,
  getPollsAllReservationResolver,
  getPollsAllSatisfactionResolver
} from '../../shared/services/resolvers/get-poll.resolver';
import {getScheduledEmailLogs} from '../../shared/services/resolvers/get-scheduled-emails-logs';
import {
  getUnitResolver,
  getUnitsResolver,
  getUnitUserResolver,
} from '../../shared/services/resolvers/get-unit.resolver';
import {getUserResolver} from '../../shared/services/resolvers/get-user.resolver';
import {CustomersComponent} from './customers/customers.component';
import {EmailSendingComponent} from './email-sending/email-sending.component';
import {ProfileComponent} from './profile/profile.component';
import {QrCodeComponent} from './qr-code/qr-code.component';
import {RegistrationComponent} from './registration.component';
import {UnitEditComponent} from './units/unit-edit/unit-edit.component';
import {UnitsComponent} from './units/units.component';
import {UserComponent} from './users/user/user.component';
import {UsersComponent} from './users/users.component';

export const registrationRoutes: Routes = [
  {
    path: '',
    loadComponent: () => RegistrationComponent,
    children: [
      {
        path: '',
        redirectTo: 'users',
        pathMatch: 'full',
      },
      {
        path: 'users',
        title: 'Usuários',
        loadComponent: () => UsersComponent,
      },
      {
        path: 'new-user',
        title: 'Novo Usuário',
        resolve: {
          profiles: getAllProfileResolver,
        },
        loadComponent: () => UserComponent,
      },
      {
        path: 'user/:id',
        title: 'Editar Usuário',
        resolve: {
          user: getUserResolver,
          profiles: getAllProfileResolver,
        },
        loadComponent: () => UserComponent,
      },
      {
        path: 'customers',
        title: 'Clientes',
        resolve: {
          customers: getCustomersResolver,
        },
        loadComponent: () => CustomersComponent,
      },
      {
        path: 'units',
        title: 'Unidades',
        resolve: {
          units: getUnitsResolver,
        },
        loadComponent: () => UnitsComponent,
      },
      {
        path: 'unit/:id',
        title: 'Editar Unidade',
        resolve: {
          unit: getUnitResolver,
          pollsSatisfaction: getPollsAllSatisfactionResolver,
          pollsReservation: getPollsAllReservationResolver,
        },
        loadComponent: () => UnitEditComponent,
      },
      {
        path: 'profiles',
        title: 'Perfis',
        resolve: {
          profiles: getAllProfileResolver,
          permissions: getAllPermissionResolver,
        },
        loadComponent: () => ProfileComponent,
      },
      {
        path: 'emails',
        title: 'Envio de E-mails',
        resolve: {
          logs: getScheduledEmailLogs,
        },
        loadComponent: () => EmailSendingComponent,
      },
      {
        path: 'qr-code',
        title: 'Qr Code',
        resolve: {
          unit: getUnitUserResolver,
        },
        loadComponent: () => QrCodeComponent,
      },
    ],
  },
];
